<h2>Privacy Policy</h2>
<p>
  Your privacy is important to us. It is CAL's policy to respect your privacy regarding any information we may collect from you across our
  CAL Portal, <a href="https://portal.cal.lk">https://portal.cal.lk</a> and other sites we own and operate. We only ask for personal
  information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We
  also let you know why we’re collecting it and how it will be used. We only retain collected information for as long as necessary to
  provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft,
  as well as unauthorized access, disclosure, copying, use or modification. We don’t share any personally identifying information publicly
  or with third-parties, except when required to by law.
</p>

<p>This policy is effective as of 30 November 2020.</p>
